import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import reactToWebComponent from "react-to-webcomponent";
import { ThemeProvider } from "styled-components";

import { arrowLeft, home } from "@ibinder/common-icons";
import { CompanyLogo, Header } from "@ibinder/ui-common-core";
import { iBinderMainTheme } from "@ibinder/ui-common-styles";

interface HeaderProps {
  icon?: string;
  homeLink: string;
  textLink: string;
  text?: string;
}

const icons: Record<string, JSX.Element> = {
  home
};

const Index = ({ icon, homeLink, textLink, text = "" }: HeaderProps) => {
  return (
    <ThemeProvider theme={iBinderMainTheme}>
      <Header
        image={
          <a href={homeLink}>
            <CompanyLogo withText={true} />
          </a>
        }
        icon={icon && <a href={homeLink}>{icons[icon]}</a>}
      >
        {textLink && (
          <a href={textLink}>
            {arrowLeft}
            {text}
          </a>
        )}
      </Header>
    </ThemeProvider>
  );
};

Index.propTypes = {
  icon: PropTypes.string,
  homeLink: PropTypes.string.isRequired,
  textLink: PropTypes.string.isRequired,
  text: PropTypes.string
};

customElements.define(
  "ibinder-header",
  // @ts-ignore
  reactToWebComponent(Index, React, ReactDOM)
);
